import { ActionStatus } from "@webiz/redux-common";

export const is = {
  request(status?: string) {
    return status === ActionStatus.REQUEST;
  },
  success(status?: string) {
    return status === ActionStatus.SUCCESS;
  },
  fail(status?: string) {
    return status === ActionStatus.FAIL;
  },
};
